import React from 'react';
import {PropTypes} from "prop-types";

ResultStatusCell.propTypes = {
    cellContent: PropTypes.any
};

function ResultStatusCell(props) {
    const style = {
        fontWeight: '500',
        height: '25px',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        borderRadius: '10px',
        paddingLeft: '5px',
        paddingRight: '5px',
        minWidth: '120px'
    }

    const setCheckValue = (result) => {
        let value
        if (result?.match(/Без патологических изменений/i)) {
            value = "Норма"
        } else if (result?.match(/Норма/i)) {
            value = "Норма"
        } else if (result?.match(/вызов/i)) {
            value = "Вызов"
        } else if (result?.match(/ожидание/i)) {
            value = "Ожидание"
        } else if (result?.match(/переснять/i)) {
            value = "Переснять"
        } else {
            value = "Ожидание"
        }
        return value
    }
    const checkValue = typeof props.cellContent === 'string' ? setCheckValue(props.cellContent) : setCheckValue(props?.cellContent?.result)


    switch (checkValue) {
        case 'Норма':
            return <div className='row__cell'>
                <div style={{...style, color: 'black', background: 'rgba(163, 255, 155, 1)'}}>Норма</div>
            </div>
        case 'Вызов':
            return (
                <div className='row__cell'>
                    <div style={{...style, background: 'rgba(255, 0, 124, 1)'}}>Вызов</div>
                </div>
            )
        case 'Переснять':
            return (
                <div className='row__cell'>
                    <div style={{...style, background: 'rgba(255, 0, 124, 1)'}}>Переснять</div>
                </div>
            )
        case "Ожидание":
            return (
                <div className='row__cell'>
                    <div style={{...style, color: "black", background: "#e8e8e8"}}>Ожидание</div>
                </div>
            )
        default:
            return <div className='row__cell'></div>
    }


}


export default ResultStatusCell;
